/* eslint-disable @typescript-eslint/naming-convention */
import { IconFont, SignTitle } from '@/components'
import { Button, Form, Input, message, Modal, Select } from 'antd'
import styled from 'styled-components'
import { useAddTarget, useGetDomain, useGetTotal } from './utils'
import { useGetAuthorizeConfig } from '@/pages/account-center/authorize-manage/utils'
const { Option } = Select
import { Scrollbars } from 'react-custom-scrollbars'
import { useRef, useState } from 'react'
import { useRequest } from 'ahooks'
import { useMemo } from 'react'
import { useEffect } from 'react'
import { Message } from '@/components/message'
import { t } from '@/i18n'
const { useForm } = Form
export const AddEmail = props => {
  const { selectGroup, tagList, visible, close } = props
  const [form] = useForm()
  /** 用于控制滚动条位置*/
  const listRef = useRef<HTMLDivElement>(null)
  const [addTarget, addTargetLoading] = useAddTarget()
  const [getDomain, targetDomain] = useGetDomain()
  // 获取邮箱授权数量
  const [authorizeConfig, runAuthorizeConfig] = useGetAuthorizeConfig()

  const [getTotal] = useGetTotal()
  const [total, setTotal] = useState(0)
  const [errorData, setErrorData] = useState<any>()

  useEffect(() => {
    runAuthorizeConfig().catch(_ => {})
  }, [visible])
  useEffect(() => {
    setTotal(0)
    if (visible) {
      getTotal()
        .then(res => setTotal(res.data.total))
        .catch(_ => {})
    }
  }, [visible])
  const onFinish = async (values: any) => {
    const { users } = values
    let arr = []
    if (EmailTotal > 1000000) {
      Message.error(t('超出数量限制，无法添加'))
      return
    }
    users?.map((item, index) => {
      arr.push(item)
      arr[index].dept_name = selectGroup.name
      arr[index].group_id = selectGroup.id
    })
    try {
      await addTarget({ targets: arr })
      close(true)
      form.resetFields()
    } catch (error: any) {
      if (error.code == 408) {
        setErrorData(error.data)
      }
    }
  }
  const { run } = useRequest(
    (e): any => {
      let arr = null
      if (errorData?.length > 0) {
        arr = []
      }
      errorData?.map(item => {
        if ((item.index || 0) !== e.key) {
          arr.push(item)
        }
      })
      setErrorData(arr)
    },
    {
      debounceWait: 300, // 防抖等待时间, 单位为毫秒，设置后，进入防抖模式
      manual: true,
    },
  )
  const [field, setField] = useState(1)
  const EmailTotal = useMemo(() => {
    if (total >= 1000000) {
      form.setFieldsValue({ users: [] })
      return total
    }
    return total + field
  }, [field, total])

  useEffect(() => {
    const current = listRef.current
    if (!current) return
    //scrollHeight是页面的高度
    current.scrollTop = current.scrollHeight
  }, [field])

  useEffect(() => {
    if ((total >= 1000000 || EmailTotal > 1000000) && visible) {
      Message.error(t('超出数量限制，无法添加'))
    }
  }, [EmailTotal, visible, total])
  return (
    <AddEmailModal
      title={
        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
          <SignTitle show style={{ width: 84 }}>
            {t('添加邮箱')}
          </SignTitle>
          <span style={{ fontSize: 14, color: '#666666', height: 18 }}>
            {t('（已添加')} <span style={{ color: '#558492' }}>{EmailTotal}</span> /
            {authorizeConfig?.emailAuthTotal || 1000000} {t('人）')}
          </span>
        </div>
      }
      centered
      visible={visible}
      width={800}
      // bodyStyle={{ height: 540 }}
      onCancel={() => {
        close(false)
        form.resetFields()
      }}
      footer={
        <div>
          <Button
            onClick={() => {
              close(false)
              form.resetFields()
            }}
          >
            {t('取消')}
          </Button>
          <Button
            onClick={() => form.submit()}
            type="primary"
            disabled={total >= 1000000 || EmailTotal > 1000000}
          >
            {t('确定')}
          </Button>
        </div>
      }
    >
      <div style={{ paddingBottom: 14, fontSize: 12 }}>
        <span style={{ color: '#F53F3F', marginRight: 4, fontSize: 16 }}>*</span>
        {t('可添加的邮箱域名：')}
        <span style={{ color: '#558492', lineHeight: '20px' }}>
          {targetDomain?.map((item, index) => (
            <span key={item?.id}>
              {item?.domain}
              {targetDomain.length - 1 !== index && ','}
            </span>
          ))}
        </span>
        {t('如需新增邮箱域名，请在资产认证中添加域并认证。')}
      </div>
      <FormList onFinish={onFinish} form={form} layout="vertical" initialValues={{ users: [''] }}>
        <div
          style={{
            background: '#F7F8F9',
            borderRadius: 6,
            padding: 15,
            overflow: 'auto',
            height: 456,
            position: 'relative',
            paddingRight: 0,
          }}
        >
          <Form.List name="users">
            {(fields, { add, remove }) => {
              setField(fields.length)
              return (
                <>
                  <div className="email-main" ref={listRef} style={{ scrollBehavior: 'smooth' }}>
                    {fields.map(({ key, name, ...restField }) => (
                      <div style={{ display: 'flex', width: 700 }} key={key}>
                        <Form.Item
                          {...restField}
                          name={[name, 'email']}
                          label={t('邮箱')}
                          rules={[
                            { required: true, message: t('请输入邮箱') },
                            // { type: 'email', message: '请输入正确的邮箱格式' },
                            {
                              validator: (_, value: string) => {
                                if (!value) return Promise.resolve()
                                if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
                                  return Promise.reject(t('请输入正确的邮箱格式'))
                                }
                                if (
                                  value &&
                                  !targetDomain.some(item => value.includes(item.domain))
                                ) {
                                  return Promise.reject(t('邮箱域名错误'))
                                } else {
                                  return Promise.resolve()
                                }
                              },
                            },
                          ]}
                          validateStatus={
                            (errorData?.some(item => (item?.index || 0) === key) && 'error') ||
                            undefined
                          }
                          help={
                            errorData?.filter(item => (item?.index || 0) === key)?.[0]?.message ||
                            undefined
                          }
                          style={{ flex: 1 }}
                        >
                          <Input
                            placeholder={t('请输入邮箱')}
                            onChange={e => {
                              run({ name: e.target.value, key: key })
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'name']}
                          label={t('姓名')}
                          style={{ margin: '0 10px', flex: 1 }}
                          rules={[{ max: 15, message: t('姓名最多15字') }]}
                        >
                          <Input placeholder={t('请输入姓名')} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          label={t('标签')}
                          name={[name, 'tag_ids']}
                          style={{ flex: 1 }}
                        >
                          <Select
                            placeholder={t('请选择标签')}
                            mode="multiple"
                            showSearch={false}
                            showArrow
                            // maxTagCount={2}
                            // maxTagTextLength={5}
                          >
                            {tagList?.map(item => (
                              <Option value={item?.id} key={item?.id}>
                                {item?.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <IconFont
                            type={'icon-shanchu-m'}
                            style={{ marginLeft: 10, width: 14, height: 14 }}
                            onClick={() => {
                              remove(name)
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="add">
                    <div
                      onClick={() => {
                        if (EmailTotal >= 1000000) {
                          return
                        }
                        add()
                      }}
                      style={{ cursor: EmailTotal >= 1000000 ? 'no-drop' : 'pointer', width: 100 }}
                    >
                      <IconFont type="icon-zengjia" />
                      <span>{t('添加')}</span>
                    </div>
                  </div>
                </>
              )
            }}
          </Form.List>
        </div>
      </FormList>
    </AddEmailModal>
  )
}
const AddEmailModal = styled(Modal)`
  .ant-modal-body {
    padding: 16px 24px;
  }
`
const FormList = styled(Form)`
  .email-main {
    height: 406px;
    padding-right: 15px;
    overflow-y: auto;
  }
  .add {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 12px;
    border-top: 1px solid #eaedf1;
  }
`
